/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SensitivityLevel = 'LESS_STRICT' | 'BALANCED_DETECTION' | 'HIGHLY_SENSITIVE';

export const SensitivityLevel = {
    LessStrict: 'LESS_STRICT' as SensitivityLevel,
    BalancedDetection: 'BALANCED_DETECTION' as SensitivityLevel,
    HighlySensitive: 'HIGHLY_SENSITIVE' as SensitivityLevel
};

